let IS_DEV

exports.isDev = () => {
  if (IS_DEV === undefined)
    IS_DEV =
      process.env.NODE_ENV === 'development' ||
      process.env.GATSBY_DEV === 'true'
  return IS_DEV
}
